import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';
import MenuItemImage from './ItemImage';
import CurrencyFormat from '../../general/CurrencyFormat';

import './MenuItem.scss';

const MenuItem = ({ item, onSelected, renderExtra, unlimitedDesc, ...props }) => {
    return (
        <Card className="pi menu-item-card" {...props} onClick={onSelected ? () => onSelected(item) : null}>
            <MenuItemImage src={item.imageUrl} className="pi-menu-item-large-image" />
            <Card.Content>
                <MenuItemImage floated="left" size="tiny" src={item.imageUrl} className="pi-menu-item-tiny-image" />
                <Card.Header>
                    {item.name}
                </Card.Header>
                <Card.Meta className={`pi-menu-item-desc ${unlimitedDesc ? 'unlimited' : ''}`}>
                    {item.description}
                </Card.Meta>
                <Card.Meta className="pi-menu-item-price">
                    <CurrencyFormat amount={item.price} />
                </Card.Meta>
            </Card.Content>
            {renderExtra ? renderExtra() : null}
        </Card>
    );
};

MenuItem.propTypes = {
    item: PropTypes.object,
    onSelected: PropTypes.func,
    renderExtra: PropTypes.func,
    unlimitedDesc: PropTypes.bool,
};

export default MenuItem;
